import { useState } from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Button from '../components/Button';

const { Title } = Typography;

const logoUrl = 'https://zxqgsxwwkfqsawhkvspn.supabase.co/storage/v1/object/public/images//logo.png';
const bgUrl = 'https://zxqgsxwwkfqsawhkvspn.supabase.co/storage/v1/object/public/images//fundo.jpg';

const Home = () => {
  const [showExtraButtons, setShowExtraButtons] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <TopBar />

      <style>{`
        .home-section {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
        }

        .buttons-container {
          display: flex;
          gap: 16px;
          margin-top: 20px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .extra-buttons {
          display: flex;
          gap: 12px;
          margin-top: 12px;
          transition: opacity 0.3s ease, max-height 0.3s ease;
          overflow: hidden;
          opacity: 0;
          max-height: 100px;
          pointer-events: none;
          flex-wrap: wrap;
          justify-content: center;
        }

        .extra-buttons.visible {
          opacity: 1;
          max-height: 200px;
          pointer-events: auto;
  width: fit-content;
        }

        @media (max-width: 1024px) {
          .home-title {
            font-size: 4.5rem !important;
          }
        }

        @media (max-width: 600px) {
          .home-section {
            padding-top: 80px !important;
            padding-bottom: 40px !important;
          }

          .home-logo {
            width: 85vw !important;
            max-width: none !important;
            margin-bottom: 16px !important;
          }

          .home-title {
            font-size: 3rem !important;
            margin-bottom: 12px !important;
            padding: 0 10px;
          }

          .home-divider {
            width: 80% !important;
            height: 2px !important;
            margin: 8px 0 20px 0 !important;
          }

          .buttons-container {
            gap: 12px;
          }

          .extra-buttons {
            gap: 8px;
          }
        }
      `}</style>

      <section
        className="home-section"
        style={{
          padding: '120px 20px 60px',
          backgroundImage: bgUrl
            ? `linear-gradient(rgba(10, 32, 58, 0.8), rgba(10, 32, 58, 0.37)), url(${bgUrl})`
            : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          textAlign: 'center',
          transition: 'background-image 0.3s ease-in-out',
          overflow: 'auto',
        }}
      >
        {logoUrl && (
          <img
            src={logoUrl}
            alt="Logo"
            className="home-logo"
            style={{ width: '80%', marginBottom: '24px' }}
          />
        )}

        <div className="buttons-container">
          <Button
            text="Fale Conosco"
            onClick={() => {
              const numero = '13988754509';
              const mensagem = encodeURIComponent('Olá, gostaria de ser atendido(a) por um profissional.');
              window.open(`https://wa.me/${numero}?text=${mensagem}`, '_blank');
            }}
            className="home-button"
            style={{
              borderRadius: '10px',
              padding: '20px 35px',
              backgroundColor: 'transparent',
              border: '2px solid #fff',
              color: 'white',
              fontSize: '1rem',
              fontFamily: 'Questrial, sans-serif',
              cursor: 'pointer',
            }}
          />

          <Button
            text={showExtraButtons ? 'Fechar Calculo' : 'Fazer Calculo'}
            onClick={() => setShowExtraButtons((prev) => !prev)}
            className="home-button"
            style={{
              borderRadius: '10px',
              padding: '20px 35px',
              backgroundColor: 'transparent',
              border: '2px solid #fff',
              color: 'white',
              fontSize: '1rem',
              fontFamily: 'Questrial, sans-serif',
              cursor: 'pointer',
            }}
          />
        </div>

        <div className={`extra-buttons ${showExtraButtons ? 'visible' : ''}`}>
          <Button
            text="Rescisão"
            onClick={() => navigate('/construcao')}
            className="home-button"
            style={{
              borderRadius: '10px',
              padding: '15px 25px',
              backgroundColor: 'white',
              border: '2px solid #fff',
              color: '#0A203A',
              fontSize: '0.9rem',
              fontFamily: 'Questrial, sans-serif',
              cursor: 'pointer',
            }}
          />
          <Button
            text="Horas Extras"
            onClick={() => navigate('/construcao')}
            className="home-button"
            style={{
              borderRadius: '10px',
              padding: '15px 25px',
              backgroundColor: 'white',
              border: '2px solid #fff',
              color: '#0A203A',
              fontSize: '0.9rem',
              fontFamily: 'Questrial, sans-serif',
              cursor: 'pointer',
            }}
          />
        </div>
      </section>
    </>
  );
};

export default Home;
